import { Text, Portal, Modal, IconButton } from 'react-native-paper';
import { useAppSelector, useAppDispatch } from '../redux/hooks';
import { setWebModalShown } from '../redux/businessListSlice';
import { useAppTheme } from '../theme';
import EditBusinessForm from './editBusinessForm';

export default function EditBusinessModal() {
  const theme = useAppTheme();
  const dispatch = useAppDispatch();
  const { webModalShown } = useAppSelector((state) => state.businessList);

  return (
    <Portal>
      <Modal
        visible={webModalShown === 'Edit_Business'}
        onDismiss={() => dispatch(setWebModalShown('None'))}
        contentContainerStyle={{
          backgroundColor: theme.colors.background,
          padding: 20,
          minHeight: 600,
          minWidth: 600,
        }}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <IconButton
          icon="close"
          onPress={() => dispatch(setWebModalShown('None'))}
          style={{ marginLeft: 'auto' }}
        />
        <Text style={{ textAlign: 'center', fontSize: 24, fontWeight: '500' }}>
          Edit Business
        </Text>
        <EditBusinessForm />
      </Modal>
    </Portal>
  );
}
